<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    aria-label="edit library"
    i18n-aria-label="@@editLibraryLabel"
    (click)="onOpenEditLibraryDialog()"
    i18n-matTooltip="@@editLibraryTooltip"
    matTooltip="Edit library"
    [matTooltipShowDelay]="1000"
    [disabled]="(isCatchmentReportingReadonlySystem$ | async) && !(allowEditLibraryName$ | async)"
  >
    <mat-icon class="edit-icon">edit</mat-icon>
  </button>
</div>
